import styled, { css as scss} from "styled-components";
const css = scss;

export const VisualizerStyle = styled.div<{hidden?: boolean}>`
    width: 100%;
    height: 100%;
    position: relative;
    ${p => p.hidden && css`display: none;`}
`